import { FC, useState } from "react";
import { SYTLegacyTheme } from "@smile2impress/themes";
import { LocationContent } from "@smile2impress/location-content";
import { Flex } from "@smile2impress/components";
import { useTranslation } from "next-i18next";
import { axiosInstanceV2 } from "api/global";

import { NestedThemeProvider } from "components/NestedThemeProvider";

import { LocationMenuProps } from "./LocationMenu.types";

export const LocationMenu: FC<LocationMenuProps> = ({
    locale,
    city,
    onSelectCity,
    onSelectRegion,
    closeMenu,
}) => {
    const { i18n } = useTranslation("global");
    const [activeStep, setActiveStep] = useState(2);
    const handleSelectCity: typeof onSelectCity = (...params) => {
        onSelectCity(...params);
        closeMenu();
    };

    const handleSelectRegion: typeof onSelectRegion = (...params) => {
        onSelectRegion(...params);
        setActiveStep(2);
        closeMenu();
    };

    return (
        <Flex>
            <NestedThemeProvider theme={SYTLegacyTheme}>
                <LocationContent
                    i18n={{ i18n }}
                    locale={locale}
                    {...(city
                        ? {
                              predefinedCity: {
                                  id: String(city.id),
                                  value: city.name,
                              },
                          }
                        : {})}
                    onSelectCity={handleSelectCity}
                    onSelectRegion={handleSelectRegion}
                    defaultStep={2}
                    activeStep={activeStep}
                    mode={"popup"}
                    axiosInstance={axiosInstanceV2}
                />
            </NestedThemeProvider>
        </Flex>
    );
};
